export class LoginAttempt {
	public username: string;
	public ipAddress: string;
	public createdAt: string;
	public isSuccessful: boolean;
	public id: string;
}

